import { SxStyles } from 'types/styles';

export const styles: SxStyles = {
  checkbox: { p: 0 },
  checked: {
    p: 0,
    width: 18,
    height: 18,
    borderWidth: 1,
    borderRadius: 1,
    borderColor: 'mainPalette.primary',
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:before': {
      content: '""',
      width: 10,
      height: 10,
      borderRadius: 0.5,
      backgroundColor: 'mainPalette.primary',
    },
    '&:hover': {
      borderColor: 'mainPalette.primary',
    },
  },
  icon: {
    p: 0,
    zIndex: 1,
    width: 18,
    height: 18,
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'mainPalette.primary',
    transition: 'border-color 0.2s',
    '&:hover': {
      transition: 'border-color 0.2s',
    },
  },
};
